export default "__VITE_ASSET__nz$CX5OR__"